"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = exports.setupStore = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const reducers_1 = __importDefault(require("./reducers"));
function setupStore(preloadedState) {
    const store = (0, toolkit_1.configureStore)({
        reducer: reducers_1.default,
        preloadedState,
    });
    return store;
}
exports.setupStore = setupStore;
exports.store = setupStore();
exports.default = exports.store;
